<template>
  <div>
    <v-layout column v-if="shopLoad" align-center>
      <!-- <v-progress-circular style="margin-top:100px" color="red lighten-3" size="64" indeterminate></v-progress-circular> -->
      <progress-q></progress-q>
    </v-layout>
    <v-layout row>
      <v-flex xs12 sm12 md12 lg8 offset-lg2>
        <v-card v-if="!shopLoad" class="dash-card">
          <v-toolbar class="q-orange-bk q-text-whitesmoke">
            <v-toolbar-title>{{getString('Opzioni negozio')}}</v-toolbar-title>
          </v-toolbar>
          <v-layout row wrap>
            <v-flex xs12 sm12 md12 lg6>
              <v-card-text>
                <v-flex xs12 sm12 md12 lg12>
                  <h3>{{getString('Numero di giorni massimo in cui si può effettuare una prenotazione (massimo 180 giorni, 6 mesi)')}}</h3>
                  <v-text-field
                    style="margin:10px;max-width:300px"
                    v-model.number="options.maxDaysFromReservation"
                    :rules="numRule"
                    solo
                    :label="getString('')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12 lg12>
                  <h3>{{getString('Numero massimo di servizi cui un cliente può prenotarsi')}}</h3>
                  <v-text-field
                    style="margin:10px;max-width:300px"
                    v-model.number="options.maxServicesForReservation"
                    :rules="numRule"
                    solo
                    :label="getString('')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12 lg12>
                  <h3>{{getString('Tempo tra una prenotazione e l\'altra (in minuti).')}}</h3>
                  <v-text-field
                    style="margin:10px;max-width:300px"
                    v-model.number="options.busyMinutes"
                    :rules="numRule"
                    solo
                    :label="getString('')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12 lg12>
                  <h3>{{getString(`Il tempo massimo entro il quale un utente può annullare la prenotazione dall'app (in minuti).`)}}</h3>
                  <label>{{getString('Es. Con 10 minuti, un utente prenotato alle 9:00 può annullare la prenotazione entro le 8:50')}}</label>
                  <v-text-field
                    style="margin:10px;max-width:300px"
                    v-model="options.maxDeleteTime"
                    :rules="numRule"
                    solo
                    :label="getString('')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12 lg12>
                  <h3>{{getString(`Tempo massimo entro il quale un utente può prenotarsi dall'app ad un determinato orario (in minuti).`)}}</h3>
                  <label>{{getString('Es. Con 10 minuti, un utente può prenotarsi alle 09:00 massimo entro le 8:50')}}</label>
                  <v-text-field
                    style="margin:10px;max-width:300px"
                    v-model="options.minMinuteReservation"
                    :rules="numRule"
                    solo
                    :label="getString('')"
                  ></v-text-field>
                </v-flex>
              </v-card-text>
            </v-flex>
            <v-flex xs12 sm12 md12 lg6>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md12 lg12>
                    <h3>{{getString('Mostra la dashboard')}}</h3>
                    <label>{{getString('Mostra o nasconde le statistiche dalla pagina principale')}}</label>
                    <v-checkbox
                      color="orange"
                      :label="`Visibile? ${options.dashboard ? getString('Sì'): 'No'}`"
                      v-model="options.dashboard"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg12>
                    <h3>{{getString(`Seleziona l'audio delle notifiche di prenotazione`)}}</h3>
                    <v-select
                      solo
                      color="#212121"
                      v-model="options.alert"
                      :items="sounds"
                      v-bind:label="getString(`Scegli l'audio`)"
                    ></v-select>
                    <audio ref="soundNotify" preload="none" controls="controls">
                      <source :src="selectedSound" />
                    </audio>
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg12>
                    <h3>{{getString(`Seleziona l'audio delle notifiche di annullamento`)}}</h3>
                    <v-select
                      solo
                      color="#212121"
                      v-model="options.alertDelete"
                      :items="sounds"
                      v-bind:label="getString(`Scegli l'audio`)"
                    ></v-select>
                    <audio ref="soundNotifyDelete" preload="none" controls="controls">
                      <source :src="selectedSoundDelete" />
                    </audio>
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg12>
                    <h3>{{getString('Numero massimo prenotazioni per utente')}}</h3>
                    <p>{{getString('Indica il numero massimo di prenotazioni che può effettuare un utente con il tuo negozio')}}</p>
                    <v-flex xs12>
                      <v-slider
                        v-model="options.maxReservationForUser"
                        :label="options.maxReservationForUser + ' ' + getString('prenotazioni')"
                        :max="10"
                        :min="1"
                        :step="1"
                      ></v-slider>
                    </v-flex>
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg12>
                    <h3>{{getString('Abilita i tempi dinamici')}}</h3>
                    <v-expansion-panel>
                      <v-expansion-panel-content>
                        <div slot="header">
                          <label>{{getString('Calcola i tempi delle prenotazioni in base ai servizi scelti')}}</label>
                          <v-checkbox
                            color="orange"
                            :label="`Vuoi usare i tempi dinamici? ${options.dynamicTimes ? getString('Sì'): 'No'}`"
                            v-model="options.dynamicTimes"
                          ></v-checkbox>
                        </div>
                        <p style="padding:5px">{{getString('Questa opzione permette di calcolare i tempi delle singole prenotazioni in base ai servizi scelti. Se per esempio un cliente sceglie un taglio da 30min insieme ad una barba da 10min, il sistema calcolerà la durata della prenotazione di 40min. Se si disattiva l\'opzione la durata della prenotazione dipenderà esclusivamente dal valore scelto in questa pagina.')}}</p>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-btn
              flat
              color="orange"
              :class="{'save-alert' : saveAlert}"
              @click="setShopOptions"
            >{{getString('Salva')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Utils from "../../../utils.js";
import ajax from "../../../ajax.js";
import ProgressQ from "../ProgressQ";
var ut = new Utils();
export default {
  name: "ShopOptions",
  props: ["shopID", "tab"],
  components: {
    ProgressQ
  },
  mounted: function() {
    this.getShopOptions();
  },
  computed: {
    selectedSound: function() {
      return "../../../../static/audio/" + this.options.alert;
    },
    selectedSoundDelete: function() {
      return "../../../../static/audio/" + this.options.alertDelete;
    },
    tenMinRule: function() {
      return [
        v => Number.parseInt(v) >= 10 || this.getString("Minimo 10 minuti")
      ];
    },
    minLenghtRule: function() {
      return [
        v =>
          ut.MinLengthValidate(v, 8) ||
          this.getString("Password troppo corta, almeno 8 caratteri")
      ];
    },
    notEmpty: function() {
      return [v => !!v || this.getString("Campo richiesto")];
    },
    urlRule: function() {
      return [v => ut.validateUrl(v) || this.getString("Url non valido")];
    },
    emailRule: function() {
      return [
        v => !!v || this.getString("Campo richiesto"),
        v => ut.ValidateEmail(v) || this.getString("Email non valida")
      ];
    },
    numRule: function() {
      return [
        v => !!v || this.getString("Campo richiesto"),
        v => ut.ValidateNumber(v) || this.getString("Numero non valido")
      ];
    },
    saveAlert: function() {
      if (this.tab !== 5) return false;
      let val =
        this.oldOptions.dynamicTimes !== this.options.dynamicTimes ||
        this.oldOptions.minMinuteReservation !==
          this.options.minMinuteReservation ||
        this.oldOptions.busyMinutes !== this.options.busyMinutes ||
        this.oldOptions.maxDeleteTime !== this.options.maxDeleteTime ||
        this.oldOptions.alert !== this.options.alert ||
        this.oldOptions.dashboard !== this.options.dashboard ||
        this.oldOptions.maxReservationForUser !==
          this.options.maxReservationForUser;
      if (val && !this.$store.state.modifying) {
        this.$store.commit("isModifying");
      }
      if (!val && this.$store.state.modifying) {
        this.$store.commit("notIsModifying");
      }
      return val;
    },
    shopLoad: function() {
      return this.options.idOption === 0;
    }
  },
  data: () => {
    return {
      h: null,
      sounds: [
        {
          text: "Ding",
          value: "sweet.wav"
        },
        {
          text: "Notification",
          value: "mixkit-bell-notification-933.wav"
        },
        {
          text: "Correct answer",
          value: "mixkit-correct-answer-reward-952.wav"
        },
        {
          text: "Wrong answer",
          value: "mixkit-wrong-answer-fail-notification-946.wav"
        },
        {
          text: "You're making cash!",
          value: "cash.wav"
        },
        {
          text: "The cow verse",
          value: "cow.wav"
        },
        {
          text: "He's Batman",
          value: "batman.wav"
        },
        {
          text: "Crash Bandicoot",
          value: "crash.wav"
        },
        {
          text: "Mario take coin",
          value: "mariocoin.wav"
        },
        {
          text: "Aggressive beast roar",
          value: "mixkit-aggressive-beast-roar-13.wav"
        },
        {
          text: "Arcade retro game",
          value: "mixkit-arcade-retro-game-over-213.wav"
        },
        {
          text: "Cartoon toy whistle",
          value: "mixkit-cartoon-toy-whistle-616.wav"
        },
        {
          text: "Dog barking twice",
          value: "mixkit-dog-barking-twice-1.wav"
        },
        {
          text: "Fast rocket whoosh",
          value: "mixkit-fast-rocket-whoosh-1714.wav"
        },
        {
          text: "Fast small sweep",
          value: "mixkit-fast-small-sweep-transition-166.wav"
        },
        {
          text: "Sad gameover trombone",
          value: "mixkit-sad-game-over-trombone-471.wav"
        },
        {
          text: "Wild lion animal roar",
          value: "mixkit-wild-lion-animal-roar-6.wav"
        },
      ],
      options: {
        idOption: 0,
        dynamicTimes: 1,
        minMinuteReservation: 10,
        busyMinutes: 30,
        maxDeleteTime: 15,
        maxReservationForUser: 3,
        alert: "sweet.wav",
        alertDelete: "sweet.wav",
        dashboard: 1,
        maxServicesForReservation: 5000,
        maxDaysFromReservation: 60
      },
      oldOptions: {
        dynamicTimes: 1,
        minMinuteReservation: 10,
        busyMinutes: 30,
        maxDeleteTime: 15,
        alert: "sweet.wav",
        dashboard: 1,
        maxReservationForUser: 3,
        maxServicesForReservation: 5000,
        maxDaysFromReservation: 60
      }
    };
  },
  watch: {
    shopID: function() {
      if (this.shopID > 0) {
        this.getShopOptions();
      }
    },
    selectedSound: function() {
      this.playAudio();
    },
    selectedSoundDelete: function() {
      this.playAudioDelete();
    }
  },
  methods: {
    playAudio: function() {
      if (this.$refs.soundNotify !== undefined) {
        this.$refs.soundNotify.load();
        this.$refs.soundNotify.play();
      }
    },
    playAudioDelete: function() {
      if (this.$refs.soundNotifyDelete !== undefined) {
        this.$refs.soundNotifyDelete.load();
        this.$refs.soundNotifyDelete.play();
      }
    },
    getString: function(key) {
      let page = this.$store.state.currentTranslator.getString(key);
      return page;
    },
    getShopOptions: function() {
      let self = this;
      if (self.shopID > 0) {
        ajax.axios
          .get(
            ajax.baseUrl() + "/admin/shops/shop/" + self.shopID + "/options",
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true
            }
          )
          .then(function(response) {
            ajax.validateToken(response.headers, self.$store);
            self.options = response.data.data;
            self.options.dashboard = self.options.dashboard > 0;
            self.oldOptions.dynamicTimes = self.options.dynamicTimes;
            self.oldOptions.minMinuteReservation =
              self.options.minMinuteReservation;
            self.oldOptions.busyMinutes = self.options.busyMinutes;
            self.oldOptions.maxDeleteTime = self.options.maxDeleteTime;
            self.oldOptions.alert = self.options.alert;
            self.oldOptions.dashboard = self.options.dashboard;
            self.oldOptions.maxReservationForUser =
              self.options.maxReservationForUser;
            self.oldOptions.maxServicesForReservation =
              self.options.maxServicesForReservation;
            self.oldOptions.maxDaysFromReservation =
              self.options.maxDaysFromReservation;
          })
          .catch(function(error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          });
      }
    },
    setShopOptions: function() {
      let self = this;
      if (self.shopID > 0) {
        ajax.axios
          .put(
            ajax.baseUrl() + "/admin/shops/shop/" + self.shopID + "/options",
            self.options,
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true
            }
          )
          .then(function(response) {
            ajax.validateToken(response.headers, self.$store);
            self.$emit(
              "siteAlertSuccess",
              self.getString("Configurazione salvata")
            );
            self.options = response.data.data;
            self.options.dashboard = self.options.dashboard > 0;
            self.oldOptions.dynamicTimes = self.options.dynamicTimes;
            self.oldOptions.minMinuteReservation =
              self.options.minMinuteReservation;
            self.oldOptions.busyMinutes = self.options.busyMinutes;
            self.oldOptions.maxDeleteTime = self.options.maxDeleteTime;
            self.oldOptions.alert = self.options.alert;
            self.oldOptions.dashboard = self.options.dashboard;
            self.oldOptions.maxReservationForUser =
              self.options.maxReservationForUser;
            self.oldOptions.maxServicesForReservation =
              self.options.maxServicesForReservation;
            self.oldOptions.maxDaysFromReservation =
              self.options.maxDaysFromReservation;
          })
          .catch(function(error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          });
      }
    }
  }
};
</script>

<style scoped>
.avatar-img {
  width: 100%;
  max-height: 300px;
  object-fit: cover;
  transition: max-height 0.3s ease-in-out;
}

.avatar-img:hover {
  max-height: 600px;
}

.save-alert {
  animation-name: saveAlertAnimation1 !important;
  animation-timing-function: linear !important;
  animation-duration: 1s !important;
  animation-iteration-count: infinite !important;
}

@keyframes saveAlertAnimation1 {
  0% {
    background-color: transparent;
  }

  50% {
    background-color: bisque;
  }

  100% {
    background-color: transparent;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/backend/pieces/ShopOptions.vue